<template>
	<div>
		<v-tooltip bottom>
			<template #activator="{ on, attrs }">
				<v-icon
					v-bind="attrs"
					class="igdb-import-btn"
					v-on="on"
					@click="openDialog"
				>
					{{ icons.mdiDatabaseImport }}
				</v-icon>
			</template>
			<span>Import IGDB game</span>
		</v-tooltip>

		<v-dialog
			v-model="dialog"
			max-width="400"
			@keydown.esc="closeDialog"
		>
			<v-card>
				<v-card-title class="text-subtitle-1 font-weight-semibold pb-2">
					Import game from IGDB
				</v-card-title>

				<v-card-text class="pb-2">
					<v-text-field
						v-model="igdbId"
						label="IGDB ID"
						placeholder="Ex: 119388"
						outlined
						dense
						autofocus
						:disabled="loading"
						:error-messages="errorMsg"
						hide-details="auto"
						@keydown.enter="doImport"
					/>
				</v-card-text>

				<v-card-text
					v-if="loading"
					class="d-flex align-center pt-0 pb-3"
				>
					<v-progress-circular
						indeterminate
						size="16"
						width="2"
						color="primary"
						class="me-2"
					/>
					<span class="text-caption">Importing, please wait...</span>
				</v-card-text>

				<v-card-text
					v-else-if="successMsg"
					class="d-flex align-center pt-0 pb-3"
				>
					<v-icon
						small
						color="success"
						class="me-1"
					>
						{{ icons.mdiCheckCircleOutline }}
					</v-icon>
					<span class="text-caption success--text">{{ successMsg }}</span>
				</v-card-text>

				<v-card-actions class="pt-0">
					<v-spacer />
					<v-btn
						text
						small
						:disabled="loading"
						@click="closeDialog"
					>
						Cancel
					</v-btn>
					<v-btn
						color="primary"
						small
						:disabled="loading || !igdbId"
						@click="doImport"
					>
						Import
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mdiDatabaseImport, mdiCheckCircleOutline } from '@mdi/js'
import axios from 'axios'

export default {
	data() {
		return {
			dialog: false,
			igdbId: '',
			loading: false,
			errorMsg: '',
			successMsg: '',
			icons: {
				mdiDatabaseImport,
				mdiCheckCircleOutline,
			},
		}
	},
	methods: {
		openDialog() {
			this.igdbId = ''
			this.errorMsg = ''
			this.successMsg = ''
			this.loading = false
			this.dialog = true
		},
		closeDialog() {
			if (this.loading) return
			this.dialog = false
		},
		async doImport() {
			if (!this.igdbId || this.loading) return

			this.errorMsg = ''
			this.successMsg = ''
			this.loading = true

			try {
				const id = String(this.igdbId).trim()
				await axios.get(`https://api.mundogamer.community/api/games/import-missing/${id}`)
				this.successMsg = `Game with IGDB ID ${id} imported successfully!`
				this.igdbId = ''
			} catch (err) {
				const msg = err?.response?.data?.message || err?.message || 'Failed to import game.'
				this.errorMsg = msg
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style scoped>
.igdb-import-btn {
	cursor: pointer;
	opacity: 0.7;
	transition: opacity 0.2s;
}
.igdb-import-btn:hover {
	opacity: 1;
}
</style>
